import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HomePage from "./pages/homepage/HomePage";
import { BrowserRouter, Routes, Route } from "react-router";
import reportWebVitals from "./reportWebVitals";
import Gallery from "./pages/gallery/Gallery";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import OffersPage from "./pages/offers/Offers";
import { ScrollToTop } from "./components/utils/scrollTop";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/o-nas" element={<About />} />
      <Route path="/oferta" element={<OffersPage />} />
      <Route path="/galeria" element={<Gallery />} />
      <Route path="/kontakt" element={<Contact />} />
    </Routes>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
